import styled from '@emotion/styled'

import { breakpoints, palette, spacing, Text, typography } from 'main/ui'

export const Container = styled.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 1;
`

export const ContentContainer = styled.div<{ sticky: boolean }>`
  background-color: ${palette.white};
  box-shadow: ${({ sticky }) => (sticky ? '0px 1px 4px rgba(0, 0, 0, 0.25)' : '')};
  width: inherit;
`

export const LeftAndRightContainer = styled.div`
  display: flex;
  flex-grow: 1;
  margin-left: 24px;

  @media (max-width: ${breakpoints.md}px) {
    padding-left: ${spacing.minorScale(2)}px;
  }
`

export const MainContentContainer = styled.div<{ backgroundColor?: string }>`
  align-items: center;
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : 'inherit')};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: ${breakpoints.md}px) {
    padding-top: ${spacing.minorScale(3)}px;
  }
`

export const LeftContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 ${spacing.majorScale(2)}px 0 0;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(2)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    > :not(:last-child) {
      margin-right: ${spacing.majorScale(2)}px;
    }
  }
`

export const TitleContainer = styled(Text)`
  color: ${palette.indigoDye};
  font-family: ${typography.fontFamily.nm};
  font-weight: ${typography.fontWeight.bold};
  font-size: ${typography.fontSize.text};
  line-height: 19px;

  @media (max-width: ${breakpoints.sm}px) {
    font-size: ${typography.fontSize.tag};
  }
`

export const RightContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 0 ${spacing.majorScale(1)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(3)}px;
  }
`

export const SearchFormContainer = styled.div`
  padding: ${spacing.minorScale(1)}px 0;

  @media (max-width: ${breakpoints.sm}px) {
    display: flex;
    padding: ${spacing.majorScale(2)}px;
    flex-grow: 1;
  }
`

export const ActionsContainer = styled.div`
  margin-right: ${spacing.majorScale(2)}px;
`

export const HamburgerIconContainer = styled.div`
  color: ${palette.mediumGray};
  height: 25px;
  width: 25px;
`

export const MenuContainer = styled.div`
  height: calc(100vh - 65px);
  position: absolute;
  right: 0;
  top: 65px;
  z-index: 2;

  @media (min-width: ${breakpoints.lg}px) {
    height: calc(100vh - 71px);
    top: 71px;
  }
`

export const MenuBackdrop = styled.div`
  background-color: ${palette.black};
  height: calc(100vh - 65px);
  left: 0;
  opacity: 0.6;
  position: absolute;
  top: 65px;
  width: 100%;
  z-index: 1;

  @media (min-width: ${breakpoints.lg}px) {
    top: 71px;
  }
`

export const Logo = styled.img`
  height: 20px;
`
